<template>
  <div v-if="!item.hidden && shouldShow">
    <!--    main item - one link -->
    <template
      v-if="
        hasOneShowingChild(item.children, item) &&
        (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
        !item.alwaysShow
      "
    >
      <app-link
        v-if="onlyOneChild.meta"
        :to="resolvePath(onlyOneChild.path, onlyOneChild.meta)"
        tabindex="0"
      >
        <el-menu-item
          :index="resolvePath(onlyOneChild.path)"
          :class="{ 'submenu-title-noDropdown': !isNest }"
          role="menuitem"
        >
          <item
            :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
            :title="onlyOneChild.meta.title"
          />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <item
          v-if="item.meta"
          :icon="item.meta && item.meta.icon"
          :title="item.meta.title"
          tabindex="0"
        />
      </template>
      <template>
        <sidebar-item
          v-for="child in item.children"
          :key="child.path"
          :is-nest="true"
          :item="child"
          :base-path="resolvePath(child.path)"
          class="nest-menu"
          :aria-label="'Submenu item: ' + (child.meta ? child.meta.title : 'Unknown')"
          role="menuitem"
        />
      </template>
    </el-submenu>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { evaluateRouteMeta } from '@/utils/routeFeatureFlagMeta'

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

import path from 'path'
import Item from './Item'
import AppLink from './Link'
import FixiOSBug from './FixiOSBug'

export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      default: '',
    },
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null
    return {}
  },

  computed: {
    ...mapState({
      activeCharityInfo: (state) => state.charities.activeCharityInfo,
    }),
    ...mapState('featureFlags', ['values']),

    shouldShow() {
      if (
        this.item.meta &&
        (this.item.meta.featureFlagKey ||
          (this.item.meta.featureFlagKeysAny && this.item.meta.featureFlagKeysAny.length))
      ) {
        return evaluateRouteMeta(this.item.meta, this.values)
      }

      return true
    },
  },

  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter((item) => {
        if (item.hidden) {
          return false
        }

        // Temp set(will be used if only has one showing child)
        this.onlyOneChild = item
        return true
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    resolvePath(routePath, meta) {
      if (meta && meta.webAppLink && this.activeCharityInfo) {
        routePath = this.$options.filters.webAppLink(meta.webAppLink, this.activeCharityInfo)
      }

      if (meta && meta.newWebAppLink && this.activeCharityInfo) {
        routePath = this.$options.filters.newWebAppLink(meta.newWebAppLink, this.activeCharityInfo)
      }

      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }

      if (meta && meta.saveParams) {
        // Create a copy of the `$route.query` object containing only the properties listed in `saveParams`
        const filteredObj = Object.fromEntries(
          Object.entries(this.$route.query).filter(([key]) => meta.saveParams.includes(key))
        )

        if (Object.keys(filteredObj).length) {
          const searchParams = new URLSearchParams(filteredObj)
          return path.resolve(this.basePath, routePath) + '?' + searchParams.toString()
        }
      }

      return path.resolve(this.basePath, routePath)
    },
  },
}
</script>
